const start = function () {
  if (!window.Handlebars) return setTimeout(start, 500);

  Handlebars.registerHelper("sizeImage", function (src) {
    return src.replace("_small", "_x150").replace("http:", "");
  });

  Handlebars.registerHelper("ifLte", function (v1, v2, options) {
    if (v1 <= v2) {
      return options.fn(this);
    }

    return options.inverse(this);
  });

  Handlebars.registerHelper("ifEquals", function (arg1, arg2, options) {
    return arg1 == arg2 ? options.fn(this) : options.inverse(this);
  });
};

start();

!(function (e, t, i, n, o, s, r, a, l, d, h) {
  function c() {
    var t = e(this);
    t.css("display", "block");
    var i = t.find(".modal-dialog"),
      n = (u.height() - i.height()) / 2,
      o = parseInt(i.css("marginTop"), 10),
      s = parseInt(i.css("marginBottom"), 10);
    s > n && (n = s), o !== n && i.css("margin-top", n);
  }
  var u = e(window),
    m = e(document),
    f = e(document.body);
  (window.JM = {}),
    (JM.Util = {
      getUrlHash: function () {
        return window.location.hash.slice(1);
      },
      setUrlHash: function (e) {
        return (
          e && e.length ? (window.location.hash = e) : this.clearUrlHash(), !0
        );
      },
      clearUrlHash: function () {
        if (window.history && window.history.pushState)
          history.replaceState(
            "",
            document.title,
            window.location.pathname + window.location.search
          );
        else {
          var e = document.body.scrollTop,
            t = document.body.scrollLeft;
          (window.location.hash = ""),
            (document.body.scrollTop = e),
            (document.body.scrollLeft = t);
        }
        return !0;
      },
    }),
    (JM.breakpoints = (function () {
      function t() {
        var e,
          t = u.width();
        return (e = t < o.xs ? r.xs : t < o.sm ? r.sm : t < o.md ? r.md : r.lg);
      }
      function i() {
        var e = t();
        e !== l && ((l = e), f.trigger(a));
      }
      var n = { xs: 480, sm: 768, md: 992, lg: 1200 },
        o = { xs: n.sm - 1, sm: n.md - 1, md: n.lg - 1, lg: 9999 },
        r = {
          xs: "viewport-xs",
          sm: "viewport-sm",
          md: "viewport-md",
          lg: "viewport-lg",
        },
        a = "breakpoints.change",
        l = "";
      return (
        (function () {
          (l = t()), e(window).on("resize", s.throttle(i, 100));
        })(),
        e.extend(n, { viewportEventName: a })
      );
    })()),
    (JM.Screen = {
      getDocHeight: function () {
        var e = document.body,
          t = document.documentElement;
        return Math.max(
          e.scrollHeight,
          e.offsetHeight,
          t.clientHeight,
          t.scrollHeight,
          t.offsetHeight
        );
      },
    }),
    (JM.SharingPopup = function (e, t, i) {
      if (e !== h) {
        (t = t || "500"), (i = i || "400");
        var n =
            "undefined" != typeof e.attr("title")
              ? e.attr("title")
              : "Share the Love",
          o = "width=" + t + ",height=" + i + ",resizable=yes";
        return (
          (this.objWindow = window.open(e.attr("href"), n, o).focus()), this
        );
      }
    });
  var p = function (t) {
      var i,
        n = "is-open",
        o = ".jm.dropdown",
        r = { open: "open" + o, close: "close" + o },
        a = {
          $toggle: h,
          onOpen: e.noop,
          onClose: e.noop,
          touch: !1,
          interactionTimeoutMs: 3500,
        };
      return (
        (a = e.extend(a, t)),
        (this.$toggle = a.$toggle),
        (this.$el = e(this.$toggle.data("dropdown"))),
        this.$toggle === h || this.$el === h
          ? (console.warn(
              "[JMDropdown] - Options argument must have '$toggle' property with valid 'data-dropdown' selector attribute"
            ),
            !1)
          : ((this._onOpen = function () {
              return this.$el.focus(), this;
            }),
            (this._onClose = function () {
              return this.$el.blur(), this;
            }),
            (this._isMobile = function () {
              return u.width() < JM.breakpoints.sm;
            }),
            (this._isVisible = function () {
              return this.$el.hasClass(n);
            }),
            (this._toggleVisibility = function () {
              return this._isVisible() ? this.close() : this.open();
            }),
            (this._setInteractionTimeout = function () {
              return (
                (i = setTimeout(this.close.bind(this), a.interactionTimeoutMs)),
                this
              );
            }),
            (this._clearInteractionTimeout = function () {
              return i && (clearTimeout(i), (i = null)), this;
            }),
            (this._onResize = function () {
              this._isMobile() && this.close();
            }),
            (this._onToggleClick = function (e) {
              return this._isMobile();
            }),
            (this._onToggleMouseenter = function () {
              this.open();
            }),
            (this._onToggleTouchClick = function (e) {
              return e.preventDefault(), this._toggleVisibility(), !1;
            }),
            (this._onKeydown = function (e) {
              27 == e.which && this.close();
            }),
            (this._onMouseleave = function (e) {
              (this.$el.find("input:focus").length &&
                this.$el.find("input:focus").val().length) ||
                this.$el.find("button:focus").length ||
                this.close();
            }),
            (this._onDocumentClick = function (t) {
              var i = t.target,
                n = this.$el.get(0),
                o = this.$toggle.get(0);
              i === n ||
                i === o ||
                e.contains(n, i) ||
                (this.close(), t.preventDefault());
            }),
            (this.open = function (t) {
              if (!this._isVisible()) {
                this.$el.addClass(n),
                  this.$el.on("keydown" + o, this._onKeydown.bind(this)),
                  this.$el.on("mouseleave" + o, this._onMouseleave.bind(this)),
                  m.on(
                    (a.touch ? "touchend" : "click") + o,
                    this._onDocumentClick.bind(this)
                  ),
                  t === !0 &&
                    (this._setInteractionTimeout(),
                    this.$el.on(
                      "mouseenter" + o,
                      this._clearInteractionTimeout.bind(this)
                    ),
                    this.$el.on(
                      "click" + o,
                      this._clearInteractionTimeout.bind(this)
                    )),
                  this._onOpen(),
                  a.onOpen.call();
                var i = e.Event(r.open, { dropdown: this });
                this.$el.trigger(i);
              }
              return this;
            }),
            (this.close = function () {
              if (this._isVisible()) {
                this.$el.removeClass(n),
                  this._clearInteractionTimeout(),
                  this.$el.off("keydown" + o),
                  this.$el.off("mouseleave" + o),
                  this.$el.off("mouseenter" + o),
                  this.$el.off("click" + o),
                  m.off((a.touch ? "touchend" : "click") + o),
                  this._onClose(),
                  a.onClose.call();
                var t = e.Event(r.close, { dropdown: this });
                this.$el.trigger(t);
              }
              return this;
            }),
            (this._init = function () {
              return (
                u.on("resize", s.throttle(this._onResize.bind(this), 200)),
                this.$el.attr("tabindex", "-1"),
                a.touch
                  ? this.$toggle.on(
                      "click",
                      this._onToggleTouchClick.bind(this)
                    )
                  : (this.$toggle.on("click", this._onToggleClick.bind(this)),
                    this.$toggle.on(
                      "mouseenter",
                      this._onToggleMouseenter.bind(this)
                    )),
                this
              );
            }),
            this._init())
      );
    },
    g = function (t) {
      var i = [];
      return (
        (this.add = function (e) {
          return t.prototype.isPrototypeOf(e)
            ? (e.$el.on("open.jm.dropdown", this._onDropdownOpen.bind(this)),
              i.push(e),
              this)
            : void console.warn(
                "[JMDropdownManager] - You must pass in an instance of a dropdown"
              );
        }),
        (this._onDropdownOpen = function (t) {
          e.each(i, function (e, i) {
            i !== t.dropdown && i.close();
          });
        }),
        this
      );
    },
    v = function () {
      var i = e("#minisearch-toggle"),
        n = e("#minisearch-dropdown"),
        o = n.find('input[type="text"]');
      return (
        (this.onOpen = function () {
          o.focus();
        }),
        (this.onClose = function () {
          o.blur();
        }),
        (this._init = function () {
          var e = {
            $toggle: i,
            onOpen: this.onOpen.bind(this),
            onClose: this.onClose.bind(this),
            touch: t.touchevents,
          };
          this.dropdown = new p(e);
        }),
        this._init()
      );
    };
  JM.MiniSearch = h;
  var b = function () {
    return (
      (this.dropdown = new p({
        $toggle: e("#shop-dropdown-toggle"),
        touch: t.touchevents,
      })),
      this
    );
  };
  JM.JMShopDropdown = h;
  var w = function () {
    var i,
      s = this,
      a = "Adding...",
      l = e("#cart-preview-template");
    return (
      (this.$el = e("#cart-preview-dropdown")),
      (this.$cartPreviewContents = this.$el.find(".cart-preview-contents")),
      (this.$cartPreviewToggle = e(".cart-preview-toggle")),
      (this.$cartCount = e("#cart-count")),
      (this.$cartCountAmount = e("#cart-count-amount")),
      (this.$addToCartForm = e('form[action^="/cart/add"]')),
      (this.dropdown = h),
      (this.cartTemplate = r.compile(l.html())),
      (this._isMobile = function () {
        return u.width() < JM.breakpoints.md;
      }),
      (this._stripCents = function (e) {
        return e.replace(/\.00$/, "");
      }),
      (this.removeLineItem = function (e) {
        o.changeItem(e, 0, this.onCartUpdate.bind(this));
      }),
      (this.getCart = function (e) {
        o.getCart(e);
      }),
      (this.updateCountBadge = function (e) {
        return (
          this.$cartCountAmount.text(e.item_count),
          this.$cartCount.attr("data-count", e.item_count),
          this
        );
      }),
      (this.buildCartHtml = function (t) {
        var i = [],
          o = {};
        return (
          t.items.length &&
            e.each(t.items, function (e, t) {
              var o =
                "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
              null !== t.image &&
                (o = t.image
                  .replace(/(\.[^.]*)$/, "_small$1")
                  .replace("http:", "")),
                i.push({
                  line: e + 1,
                  key: t.key,
                  url: t.url,
                  img: o,
                  productTitle: t.product_title,
                  variantTitle: t.variant_title,
                  qty: t.quantity,
                  linePrice: s._stripCents(n.formatMoney(t.line_price)),
                });
            }),
          (o = {
            items: i,
            count: i.length,
            totalPrice: s._stripCents(n.formatMoney(t.total_price)),
            rawTotal: t.total_price / 100,
            fullTotal: t.total_price,
          }),
          this.cartTemplate(o)
        );
      }),
      (this.populateContainer = function (e) {
        var t = this.buildCartHtml(e);
        this.$cartPreviewContents.empty(), this.$cartPreviewContents.append(t);
      }),
      (this.onInitialCartLoad = function (e) {
        this.populateContainer(e), this.updateCountBadge(e);
      }),
      (this.onCartUpdate = function (e) {
        this.populateContainer(e),
          this.updateCountBadge(e),
          this.dropdown.open(!0);
      }),
      (this.onItemAdded = function (e) {
        this.$addToCartForm.find('[type="submit"]').text(i),
          this.getCart(this.onCartUpdate.bind(this));
      }),
      (this.onItemError = function () {
        console.warn("Something got weird..");
      }),
      (this.onRemoveLineItemClick = function (t) {
        var i = e(t.target).parents(".cart-preview-product"),
          n = i.data("line");
        return i.addClass("is-being-removed"), this.removeLineItem(n), !1;
      }),
      (this.onFormSubmit = function (e) {
        (this._isMobile() && false) ||
          (e.preventDefault(),
          this.$addToCartForm.find('[type="submit"]').text(a),
          o.addItemFromForm(
            e.target,
            this.onItemAdded.bind(this),
            this.onItemError.bind(this)
          ));
      }),
      (this._registerEventHandlers = function () {
        this.$el.on(
          "click",
          ".cart-preview-product__remove",
          this.onRemoveLineItemClick.bind(this)
        ),
          this.$addToCartForm.on("submit", this.onFormSubmit.bind(this));
      }),
      (this._initialize = function () {
        var e = { $toggle: this.$cartPreviewToggle, touch: t.touchevents };
        return (
          this.$addToCartForm.length &&
            (i = this.$addToCartForm.find('[type="submit"]').text().trim()),
          (this.dropdown = new p(e)),
          this._registerEventHandlers(),
          this.getCart(this.onInitialCartLoad.bind(this)),
          this
        );
      }),
      this._initialize()
    );
  };
  (JM.MiniCart = h),
    (JM.MobileMenu = {
      $menu: e(".mobile-menu"),
      $toggle: e(".mobile-menu-toggle"),
      close: function () {
        this.$menu.hasClass("visible") &&
          (this.$menu.removeClass("visible"),
          this.$toggle.removeClass("is-open"));
      },
      open: function () {
        this.$menu.hasClass("visible") ||
          (this.$menu.addClass("visible"), this.$toggle.addClass("is-open"));
      },
      onResize: function () {
        u.width() > JM.breakpoints.sm && this.close();
      },
      init: function () {
        u.on("resize", s.throttle(this.onResize.bind(this), 200)),
          this.$toggle.on(
            "click",
            function () {
              return (
                this.$menu.hasClass("visible") ? this.close() : this.open(), !1
              );
            }.bind(this)
          );
      },
    }),
    (JM.User = {
      firstPageOfVisit: !1,
      cookies: {
        emailCollected: {
          name: "jm-email-collected",
          value: "true",
          expiration: 3650,
        },
        subscribeModalSeenDuringSession: {
          name: "jm-subscribe-modal-seen-during-session",
          value: "true",
        },
        subscribeModalSeen: {
          name: "jm-subscribe-modal-seen",
          value: "true",
          expiration: 14,
        },
        session: { name: "jm-session", value: "true" },
        visits: { name: "jm-visits", value: 1, expiration: 3650 },
      },
      setCookie: function (e) {
        this.hasCookie(e) && this.removeCookie(e);
        var t = e.hasOwnProperty("expiration") ? { expires: e.expiration } : {};
        return i.set(e.name, e.value, t), this;
      },
      hasCookie: function (e) {
        return "undefined" != typeof i.get(e.name);
      },
      getCookie: function (e) {
        return i.get(e.name);
      },
      removeCookie: function (e) {
        return i.remove(e.name), this;
      },
      logic: {
        emailHasBeenCollected: function () {
          return JM.User.hasCookie(JM.User.cookies.emailCollected);
        },
        userFirstPageOfVisit: function () {
          return JM.User.firstPageOfVisit;
        },
        userFirstVisit: function () {
          return (
            !JM.User.hasCookie(JM.User.cookies.visits) ||
            1 === parseInt(JM.User.getCookie(JM.User.cookies.visits))
          );
        },
        userSecondVisit: function () {
          var e = JM.User.getCookie(JM.User.cookies.visits);
          return e && 2 === parseInt(e);
        },
        subscribeModalSeenDuringSession: function () {
          return JM.User.hasCookie(
            JM.User.cookies.subscribeModalSeenDuringSession
          );
        },
        subscribeModalSeenHasExpired: function () {
          return !JM.User.hasCookie(JM.User.cookies.subscribeModalSeen);
        },
      },
      init: function () {
        var e = this.cookies.session;
        if (!this.hasCookie(e)) {
          this.setCookie(e), (this.firstPageOfVisit = !0);
          var t = this.cookies.visits;
          this.hasCookie(t) &&
            ((t = jQuery.extend({}, t)), (t.value = parseInt(t.value) + 1)),
            this.setCookie(t);
        }
      },
    });
  var y = {
      initialized: !1,
      $el: e("#subscription-modal"),
      onShow: function () {
        JM.User.setCookie(JM.User.cookies.subscribeModalSeen),
          JM.User.setCookie(JM.User.cookies.subscribeModalSeenDuringSession);
      },
      onShown: function () {
        this.$el.find("input").first().focus();
      },
      shouldShow: function () {
        var e = JM.User.logic;
        return e.emailHasBeenCollected()
          ? !1
          : e.userFirstPageOfVisit() &&
            (e.userFirstVisit() || e.userSecondVisit())
          ? !0
          : !!e.subscribeModalSeenHasExpired();
      },
      initForHome: function () {
        this.initialized || this.init(),
          this.shouldShow() &&
            setTimeout(
              function () {
                this.$el.modal("show");
              }.bind(this),
              1500
            );
      },
      init: function () {
        var e = this;
        return (
          (this.initialized = !0),
          this.$el
            .on("show.bs.modal", this.onShow.bind(e))
            .on("shown.bs.modal", this.onShown.bind(e)),
          f.hasClass("template-index") && this.initForHome(),
          this
        );
      },
    },
    M = {
      slickOpts: {
        fade: !t.touchevents,
        draggable: !t.touchevents,
        speed: 400,
        arrows: !0,
        prevArrow:
          '<div class="press-nav press-nav--left"><i class="fa fa-angle-left"></i></div>',
        nextArrow:
          '<div class="press-nav press-nav--right"><i class="fa fa-angle-right"></i></div>',
        lazyLoad: "progressive",
        accessibility: !0,
      },
      handleModalShow: function (e) {
        var t = e.find(".press-modal-gallery");
        t.find("img").first();
        JM.Util.setUrlHash(e.attr("id")), e.find(".modal-body").hide();
      },
      handleModalShown: function (t) {
        function i() {
          s.fadeIn({
            duration: 400,
            start: function () {
              o.remove();
            },
            always: function () {
              r.get(0).slick.refresh(), c.apply(t);
            },
          });
        }
        var n = this,
          o = t.find(".jm-loader"),
          s = t.find(".modal-body"),
          r = t.find(".press-modal-gallery"),
          a = r.find("img").first();
        r.one("init", function () {
          var t = new Image();
          e(t).on("load", i),
            (t.src =
              a.attr("data-lazy") !== h ? a.attr("data-lazy") : a.attr("src"));
        }),
          r.slick(n.slickOpts),
          t.one("hidden.bs.modal", this.handleModalHidden.bind(this, t));
      },
      handleModalHidden: function (e) {
        var t = e.find(".press-modal-gallery");
        t.slick("unslick"),
          JM.Util.getUrlHash() === e.attr("id") && JM.Util.clearUrlHash();
      },
      attachHandlers: function () {
        var t = this;
        m.on("show.bs.modal", ".press-modal", function (i) {
          t.handleModalShow(e(this));
        }),
          m.on("shown.bs.modal", ".press-modal", function (i) {
            t.handleModalShown(e(this));
          });
      },
      init: function () {
        this.attachHandlers();
        var t = JM.Util.getUrlHash(),
          i = "#" + t + ".modal";
        t.length &&
          e(i).length &&
          setTimeout(function () {
            e(i).modal("show");
          }, 1500);
      },
    },
    k = {
      init: function () {
        var t = e(".article-wrapper"),
          i = e('<div class="article-grid"></div>'),
          n = e('<div class="article-grid__spacer"></div>'),
          o = e(t.find("img").get().reverse());
        0 !== o.length &&
          (t.addClass("article-wrapper--hidden"),
          t.prepend(i),
          i.prepend(n),
          o.each(function (t, n) {
            var o = e(n);
            o.remove(),
              i.prepend(o),
              o.wrap('<div class="article-grid__item"></div>');
          }),
          t.find("p:empty").remove(),
          i.masonry({
            columnWidth: ".article-grid__spacer",
            itemSelector: ".article-grid__item",
            gutter: 0,
            transitionDuration: 0,
            initLayout: !1,
            percentPosition: !0,
          }),
          i.masonry("on", "layoutComplete", function () {
            t.removeClass("article-wrapper--hidden");
          }),
          i.imagesLoaded(function () {
            i.masonry();
          }));
      },
    },
    _ = {
      init: function () {
        var t = e("#modal-article-image-zoom"),
          i = t.find(".modal-body"),
          n = e(".article-wrapper").find("img");
        n.each(function (t, i) {
          var n = e(i),
            o = e('<div class="img-zoom-wrapper"></div>');
          o.css("cursor", "pointer"),
            o.attr("title", "Click to enlarge"),
            n.wrap(o);
        }),
          t.on("hidden.bs.modal", function () {
            i.empty();
          }),
          m.on("click", ".img-zoom-wrapper", function () {
            if (u.width() < JM.breakpoints.sm) return !1;
            var n = e(this).find("img").clone();
            i.html(n), t.modal("show");
          });
      },
    },
    C = {
      regexes: {
        error: {
          1: /Please enter a value/,
          2: /An email address must contain a single @/,
          3: /The domain portion of the email address is invalid \(the portion after the @: (.+)\)/,
          4: /The username portion of the email address is invalid \(the portion before the @: (.+)\)/,
          5: /This email address looks fake or invalid. Please enter a real email address/,
          6: /.+\#6592.+/,
          7: /(.+@.+) is already subscribed to list (.+)\..+<a href.+/,
        },
      },
      responses: {
        success: "Thank you for subscribing!",
        error: {
          1: "Please enter an email address",
          2: "There was a problem with your entry. Please check the address and try again.",
          3: "There was a problem with your entry. Please check the address and try again.",
          4: "There was a problem with your entry. Please check the address and try again.",
          5: "There was a problem with your entry. Please check the address and try again.",
          6: "Too many subscribe attempts for this email address. Please try again in about 5 minutes.",
          7: "You're already subscribed. Thank you!",
        },
      },
      getRegexMatch: function (t, i) {
        var n,
          o = this.regexes[i];
        return (
          e.each(o, function (e, i) {
            return null !== t.match(i) ? ((n = e), !1) : void 0;
          }),
          n
        );
      },
      getMessageForResponse: function (e) {
        var t;
        if ("success" === e.result) t = this.responses.success;
        else {
          try {
            var i = e.msg.split(" - ", 2);
            t = i[1] === h ? e.msg : i[1];
          } catch (n) {
            t = e.msg;
          }
          var o = this.regexes.error,
            s = this.getRegexMatch(t, "error");
          if (s && o[s] && this.responses.error[s])
            return t.replace(o[s], this.responses.error[s]);
        }
        return t;
      },
      onBeforeSend: function (e) {
        var t = e.find('input[type="email"]');
        return t.val() && t.val().length
          ? (e
              .find(".subscribe-signup-response")
              .text("Submitting...")
              .fadeIn(100),
            !0)
          : !1;
      },
      handleOnSubmitDone: function (e, t) {
        var i = t.find(".subscribe-signup-response"),
          n = "success" === e.result,
          o = C.getMessageForResponse(e);
        n && JM.User.setCookie(JM.User.cookies.emailCollected),
          i.fadeOut(400, function () {
            i.html(o),
              i.fadeIn(400, function () {
                n && t.find('input[type="email"]').val(""),
                  setTimeout(function () {
                    i.fadeOut(1800), n && y.$el.modal("hide");
                  }, 2e3);
              });
          });
      },
      handleOnSubmitFail: function (e) {
        console.log("ajax form submit failed");
      },
      handleOnSubmit: function (t) {
        t.preventDefault();
        var i = e(this),
          n = {},
          o = i.serializeArray();
        return (
          e.each(o, function (e, t) {
            n[t.name] = t.value;
          }),
          e
            .ajax({
              url: i
                .attr("action")
                .replace("/post?", "/post-json?")
                .concat("&c=?"),
              dataType: "jsonp",
              data: n,
              beforeSend: function () {
                C.onBeforeSend(i);
              },
            })
            .done(function (e) {
              C.handleOnSubmitDone(e, i);
            })
            .fail(function () {
              C.handleOnSubmitFail(i);
            }),
          !1
        );
      },
    },
    S = {
      slideshowSelector: ".section__home-slideshow",
      settings: {
        fade: !t.touchevents,
        dots: !0,
        draggable: !t.touchevents,
        adaptiveHeight: !0,
        autoplay: !0,
        autoplaySpeed: 4e3,
        speed: t.touchevents ? 200 : 800,
        arrows: !t.touchevents,
        prevArrow:
          '<div class="home-slideshow__nav home-slideshow__nav--left"><i class="fa fa-angle-left"></i></div>',
        nextArrow:
          '<div class="home-slideshow__nav home-slideshow__nav--right"><i class="fa fa-angle-right"></i></div>',
        responsive: [{ breakpoint: 768 }],
      },
      destroy: function () {
        var t = e(this.slideshowSelector).find(".home-slideshow__slides");
        t.hasClass("slick-initialized") && t.slick("unslick");
      },
      makeSlideshow: function () {
        var t = e(this.slideshowSelector);

        if (t.find(".home-slideshow__slide").length > 1) {
          let isChanging = false;
          t.on("init breakpoint", function (event, slick) {
            if (isChanging) return true; // prevents infinite loop.

            isChanging = true;

            // window check because slick is bad & we shouldn't be using it.
            if (
              (slick.activeBreakpoint && slick.activeBreakpoint === 768) ||
              window.innerWidth <= 768
            ) {
              slick.slickFilter(":not([data-desktop-only])");
            } else {
              slick.slickUnfilter();
            }

            isChanging = false;
          });
        }

        t.find(".home-slideshow__slide").length > 1 &&
          t.find(".home-slideshow__slides").slick(this.settings);
      },
      init: function () {
        this.makeSlideshow(),
          m.on(
            "shopify:section:unload",
            this.slideshowSelector,
            this.destroy.bind(this)
          ),
          m.on(
            "shopify:section:load",
            this.slideshowSelector,
            this.makeSlideshow.bind(this)
          );
      },
    },
    $ = {
      sectionSelector: ".section__home-features",
      videoModalSelector: ".modal--home-feature-video",
      players: {},
      _createPlayer: function (e, t) {
        var i,
          n = { id: t, byline: !1, portrait: !1, color: "E0B4B1" };
        return (
          (i = new d.Player(e, n)),
          i.on("ended", this.onPlayerEnded.bind(this, i)),
          i
        );
      },
      _destroyPlayers: function () {
        s.each(
          this.players,
          function (e, t) {
            e.unload(), delete this.players[t];
          },
          this
        );
      },
      _getPlayerFromModal: function (e) {
        return (
          e &&
            e.data("feature-video-block") &&
            (player = this.players[e.data("feature-video-block")]),
          player || !1
        );
      },
      onPlayerEnded: function (t) {
        e(t.element).parents(".modal").modal("hide");
      },
      onVideoModalShow: function (e) {
        if (e) {
          var t = e.data("feature-video-block"),
            i = e.find(".modal-video-container"),
            n = i.data("video-type"),
            o = i.data("video-id");
          i && o && "vimeo" == n
            ? this.players.hasOwnProperty(t) ||
              (i.empty(), (this.players[t] = this._createPlayer(i.get(0), o)))
            : console.log(
                "[HomepageFeatures] - Modal is missing required parameters to play video"
              );
        }
      },
      onVideoModalShown: function (e) {
        var t = this._getPlayerFromModal(e);
        t &&
          t.ready().then(function () {
            t.play();
          });
      },
      onVideoModalHidden: function (e) {
        var t = this._getPlayerFromModal(e);
        t &&
          t.pause().then(function () {
            t.setCurrentTime(0);
          });
      },
      onUnload: function () {
        this._removeEventHandlers(),
          this._destroyPlayers(),
          e(this.videoModalSelector).filter(":visible").modal("hide");
      },
      onLoad: function () {
        this._addEventHandlers();
      },
      _addEventHandlers: function () {
        var t = this,
          i = e(t.videoModalSelector);
        i.on("show.bs.modal", function () {
          t.onVideoModalShow(e(this));
        }),
          i.on("shown.bs.modal", function () {
            t.onVideoModalShown(e(this));
          }),
          i.on("hidden.bs.modal", function () {
            t.onVideoModalHidden(e(this));
          });
      },
      _removeEventHandlers: function () {
        var t = e(self.videoModalSelector);
        t.off("show.bs.modal"),
          t.off("shown.bs.modal"),
          t.off("hidden.bs.modal");
      },
      init: function () {
        this._addEventHandlers(),
          m.on(
            "shopify:section:unload",
            this.sectionSelector,
            this.onUnload.bind(this)
          ),
          m.on(
            "shopify:section:load",
            this.sectionSelector,
            this.onLoad.bind(this)
          );
      },
    },
    J = {
      $el: e(".sidebar"),
      $stickyEl: e(".sidebar .sidebar-sticky-content"),
      getStickyTopPadding: function () {
        return 70;
      },
      isSticky: function () {
        return 0 !== this.$el.find(".sticky-wrapper").length;
      },
      fitsInUsableViewport: function () {
        var t = this.getStickyTopPadding(),
          i = window.innerHeight - e("header").outerHeight();
        return this.$el.outerHeight() + t <= i;
      },
      stick: function () {
        if (
          !this.$stickyEl.length ||
          this.isSticky() ||
          !this.fitsInUsableViewport()
        )
          return this;
        var t = e("header").outerHeight() + this.getStickyTopPadding(),
          i = this.$el.parent().get(0);
        return (
          this.$stickyEl.sticky({
            topSpacing: t,
            bottomSpacing:
              JM.Screen.getDocHeight() - (i.offsetTop + i.offsetHeight),
          }),
          this.$stickyEl.sticky("update"),
          this
        );
      },
      unstick: function () {
        return this.isSticky() && this.$stickyEl.unstick(), this;
      },
      onResize: function () {
        this.$stickyEl.length &&
          (this.fitsInUsableViewport()
            ? this.isSticky() || this.stick()
            : this.unstick());
      },
      onBreakpointChange: function () {
        this.$stickyEl.length &&
          window.innerWidth > JM.breakpoints.sm &&
          this.$stickyEl.sticky("update");
      },
      initSticky: function () {
        return (
          this.stick(),
          u.on(
            "resize.stickySidebar.sticky",
            s.throttle(this.onResize.bind(this), 200)
          ),
          u.on(
            JM.breakpoints.viewportEventName,
            this.onBreakpointChange.bind(this)
          ),
          this
        );
      },
      init: function () {
        return 0 !== this.$el.length
          ? (this.$stickyEl.length && this.initSticky(), this)
          : void 0;
      },
    };
  (JM.Scenes = {
    common: {
      init: function () {
        (JM.MiniCart = new w()),
          (JM.MiniSearch = new v()),
          (JM.ShopDropdown = new b()),
          (JM.DropdownManager = new g(p)),
          JM.DropdownManager.add(JM.MiniCart.dropdown),
          JM.DropdownManager.add(JM.MiniSearch.dropdown),
          JM.DropdownManager.add(JM.ShopDropdown.dropdown),
          JM.User.init(),
          JM.MobileMenu.init(),
          J.init(),
          e("#footer-signup-form, #modal-signup-form").on(
            "submit",
            C.handleOnSubmit
          ),
          m
            .on("show.bs.modal", ".modal", function () {
              var t = e(this),
                i = t.data("background"),
                n = "modal-" + i;
              c.apply(t.get(0)),
                u.on("resize.bs.modal", c.bind(t.get(0))),
                i &&
                  (f.addClass(n),
                  t.one("hidden.bs.modal", function () {
                    f.removeClass(n);
                  }));
            })
            .on("hidden.bs.modal", ".modal", function () {
              u.off("resize.bs.modal");
            }),
          y.init(),
          e(".share-dialog-link").on("click", function (t) {
            return (
              t.preventDefault(),
              new JM.SharingPopup(
                e(this),
                $link.data("share-width"),
                $link.data("share-height")
              )
            );
          }),
          f.on("focus", "input, textarea, select", function () {
            e(this).parent(".has-error") &&
              e(this).parent(".has-error").removeClass("has-error");
          }),
          t.svgasimg || e('img[src*=".svg"]').remove();
      },
    },
    template_index: {
      init: function () {
        S.init(), $.init();
      },
    },
    template_blog: {
      init: function () {
        f.is("#press") && M.init();
      },
    },
    template_article: {
      init: function () {
        e(".article-wrapper img").load(function () {
          var t = e(this)
              .attr("src")
              .replace(/_grande\.|_large\.|_medium\.|_small\./, "."),
            i = e(this).width();
          e(this).attr("src", t).attr("width", i).removeAttr("height");
        });
        f.hasClass("blog-xo-jm") | f.hasClass("blog-this-that") &&
          ((f.hasClass("article-je-taime") ||
            f.hasClass("article-image-gallery")) &&
            k.init(),
          f.hasClass("article-questionnaire") && _.init());
      },
    },
    template_cart: {
      init: function () {
        function t() {
          var e = n.val().length ? r : s;
          o.text(e);
        }
        var i = e("#cart-options-modal"),
          n = i.find("textarea"),
          o = e('[data-target="#cart-options-modal"]'),
          s = o.text(),
          r = "Edit Your Note";
        i.on("hide.bs.modal", t),
          i.on("shown.bs.modal", function () {
            n.focus();
          }),
          t();
      },
    },
    template_product: { init: function () {} },
  }),
    (JM.Util = e.extend(!0, JM.Util, {
      fire: function (e, t, i) {
        var n,
          o = JM.Scenes;
        (t = t === h ? "init" : t),
          (n = "" !== e),
          (n = n && o[e]),
          (n = n && "function" == typeof o[e][t]),
          n && o[e][t](i);
      },
      loadEvents: function () {
        JM.Util.fire("common"),
          e.each(
            document.body.className.replace(/-/g, "_").split(/\s+/),
            function (e, t) {
              JM.Util.fire(t), JM.Util.fire(t, "finalize");
            }
          ),
          JM.Util.fire("common", "finalize");
      },
    })),
    e(JM.Util.loadEvents);
})(
  jQuery,
  Modernizr,
  Cookies,
  Shopify,
  ShopifyAPI,
  _,
  Handlebars,
  Masonry,
  imagesLoaded,
  Vimeo
);
